import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { UPLOAD_STATUS } from "../upload/DocumentUpload";
import Consent from "./Consent";
import ReviewItem from "./ReviewItem";
import RequestReviewItem from "./RequestReviewItem";

function Review() {
  const { state, dispatch } = useContext(RequestSubmissionContext);
  const { t } = useTranslation();

  return (
    <div className="section">
      <div className="divider divider-green is-size-6 has-text-dark is-left">
        {t("requests.submission.review.form")}
      </div>

      <RequestReviewItem
        state={state}
        label={state.pdfForm.name}
        fileName={state.pdfForm.name + ".pdf"}
        //href={state.pdfForm.url}
        attached={true}
      />

      <div className="divider divider-green is-size-6 pt-5 has-text-dark is-left">
        {t("requests.submission.review.attachments")}
      </div>

      {state.upload.documents
        .filter((doc) => {
          return doc.required || doc.uploadStatus === UPLOAD_STATUS.SUCCESS;
        })
        .map((doc, index) => (
          <ReviewItem
            key={`doc${index}`}
            label={`${index + 1}. ${doc.label}`}
            href={doc.href}
            fileName={doc.file ? doc.file.name : null}
            attached={doc.uploadStatus === UPLOAD_STATUS.SUCCESS}
          />
        ))}

      {state.organizationUnits.length > 1 && (
        <>
          <div className="divider divider-green is-size-6 pt-5 has-text-dark is-left">
            {t("Nadležnost")}
          </div>
          <div
            className={
              state.organizationUnitId === null
                ? "select is-fullwidth is-danger"
                : "select is-fullwidth is-success"
            }
          >
            <select
              name="nadleznosti"
              id="nadleznosti"
              onChange={() => {
                dispatch({
                  type: "setOrgUnitId",
                  payload: document.getElementById("nadleznosti").value,
                });
              }}
            >
              {state.organizationUnits.map((organization, index) => (
                <option
                  key={"org" + index}
                  className={"has-text-weight-semibold"}
                  value={organization.label}
                >
                  {organization.content}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      <div className="divider divider-green is-size-6 pt-5 has-text-dark is-left">
        {t("requests.submission.review.consent")}
      </div>

      <div className="pb-2">
        <span className="has-text-danger has-text-weight-bold is-size-6 ">
          {state.review.warning.label}{" "}
        </span>
        <span className="is-size-6">{state.review.warning.content}</span>
      </div>

      {state.review.consents.map((consent, index) => (
        <Consent
          content={consent.content}
          accepted={consent.accepted}
          label={consent.label}
          key={`consent${index}`}
          onChange={() => {
            consent.accepted = !consent.accepted;
            dispatch({ type: "update-consents" });
          }}
        />
      ))}
    </div>
  );
}

export default Review;
